import { HStack } from "@chakra-ui/react";
import type { ReactNode } from "react";
import React from "react";

export function DataSourceDrawHeader({ children }: { children: ReactNode }) {
  return (
    <HStack
      w="full"
      align="center"
      justify="space-between"
      px={4}
      py={4}
      borderBottomWidth="1px"
      borderColor="gray.300"
    >
      {children}
    </HStack>
  );
}
